import { Component } from 'preact';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class ButtonOrder extends Component {
  render() {
    const { isOpen, onClick, title, icon } = this.props;

    return (
      <button
        className={classNames(
          'btn button button--large button--no-upper search--button search--button-order',
          {
            'search--button--active': isOpen,
          },
        )}
        type="button"
        onClick={e => onClick(e)}
      >
        <span>
          <span>
            {isOpen ? 'Fechar' : title}
            <i className={`icon ${icon}`} />
          </span>
        </span>
      </button>
    );
  }
}

ButtonOrder.defaultProps = {
  onClick: () => {},
  isOpen: false,
  title: 'Ordenar',
  icon: 'icon-chevron',
};

ButtonOrder.propTypes = {
  onClick() {},
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.string,
};

export default ButtonOrder;
